import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {IonicModule} from '@ionic/angular';
import {SmActionButtonModule} from '../sm-action-button/sm-action-button.module';
import {SmInputModule} from '../../form-controls/sm-input/sm-input.module';
import {SmTextareaModule} from '../../form-controls/sm-textarea/sm-textarea.module';
import {SmConfirmationDialogComponent} from './sm-confirmation-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    ReactiveFormsModule,
    SmActionButtonModule,
    SmInputModule,
    SmTextareaModule,
  ],
  declarations: [SmConfirmationDialogComponent],
  exports: [SmConfirmationDialogComponent],
})
export class SmConfirmationDialogModule {}
